(async () => {
    const { Core } = await importModule('Core');
    const EL_PARENT = '[data-cart-item]';
    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_LINE_KEY = 'line';
    const ATTR_ITEM_KEY = 'key';
    const ATTR_MIN_QTY = 'data-min-qty';
    
    class CartControl extends Core {
        get variantId() {
            const value = this.getAttribute(ATTR_VARIANT_ID);
            return value;
        }

        get sellingPlanId() {
            const value = this.getAttribute(ATTR_SELLING_PLAN_ID) || '';
            return value;
        }
        
        get $parentItem() {
            const parent = this.closest(EL_PARENT);
            return parent;
        }

        get line() {
            const value = this.getAttribute(ATTR_LINE_KEY) || 'N/A';
            return value;
        }

        get key() {
            const value = this.getAttribute(ATTR_ITEM_KEY);
            return value;
        }

        get minQty() {
            const value = parseInt(this.$parentItem?.getAttribute(ATTR_MIN_QTY), 10) || 1;
            return value;
        }

        parentLoading() {
            if (this.$parentItem) {
                this.$parentItem.classList.add(CN_LOADING);
            } else {
                console.warn("[Parent Loading] $parentItem is null or undefined.");
            }
        }
    }

    customElements.define('cart-qty-button', class extends CartControl { 
        render() {
            this.addEventListener('click', this._onQtyChange.bind(this), { once: true });
        }

        _onQtyChange(e) {
            e.preventDefault();
            if (!this.key || !this.value) {
                console.warn("[Cart Qty Button] Missing key or value. Aborting quantity change.", {
                    key: this.key,
                    value: this.value
                });
                return;
            }

            const newQuantity = this.value.toString();
            if (parseInt(newQuantity, 10) !== 0 && parseInt(newQuantity, 10) < this.minQty) {
                console.warn(`[Cart Qty Button] Quantity for ${this.key} is below minimum (${this.minQty}). Setting to minimum.`);
                this.value = this.minQty;
            }

            this.parentLoading();
            this.publish('cart:change', {
                updates: [{
                    key: this.key,
                    quantity: this.value.toString(),
                    selling_plan: this.sellingPlanId,
                    line: this.line,
                    src: this.tagName
                }]
            });
        }

        get value() {
            let value = this.getAttribute('set-value');
            return value;
        }

        set value(newValue) {
            this.setAttribute('set-value', newValue);
        }
    });

    customElements.define('cart-qty-input', class extends CartControl {
        render() {
            this.addEventListener('change', this._onQtyChange.bind(this), { once: true });
        }

        _onQtyChange(e) {
            if (!this.key || !e.target.value) {
                console.warn("[Cart Qty Input] Missing key or quantity. Aborting quantity change.", {
                    key: this.key,
                    value: e.target.value
                });
                return;
            }

            const newQuantity = e.target.value.toString();
            if (parseInt(newQuantity, 10) !== 0 && parseInt(newQuantity, 10) < this.minQty) {
                console.warn(`[Cart Qty Input] Quantity for ${this.key} is below minimum (${this.minQty}). Setting to minimum.`);
                e.target.value = this.minQty;
            }

            this.parentLoading();
            this.publish('cart:change', {
                updates: [{
                    key: this.key,
                    quantity: e.target.value.toString(),
                    selling_plan: this.sellingPlanId,
                    line: this.line,
                    src: this.tagName
                }]
            });
        }
    });
})();
